const e = {
  buttonClose: {
    id: "design_system_button_close",
    defaultMessage: "Close"
  },
  buttonClear: {
    id: "design_system_button_clear",
    defaultMessage: "Clear"
  },
  buttonLoading: {
    id: "design_system_button_loading",
    defaultMessage: "Loading"
  },
  rating: {
    id: "design_system_rating_score",
    defaultMessage: "Rating of {rating} out of {maxRating} stars"
  },
  inputPhoneCountryCode: {
    id: "design_system_input_phone_country_code",
    defaultMessage: "Country code"
  },
  searchPlaceholder: {
    id: "design_system_search_placeholder",
    defaultMessage: "Search for an item..."
  }
};
export {
  e as default
};
